angular.module("tasks_types")

    .controller("TasksTypesListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate','$state',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, $state) {

        //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("TASKS_TYPES_WRITE");

        $rootScope.title = $filter('translate')('tasks_types.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('tasks_types.title') }
        ];
        $scope.selectEntityTypes = [{ id: null, name: $filter("translate")('entity_types.all') }, { id: 'events', name: $filter("translate")('entity_types.events') }, { id: 'correspondence', name: $filter("translate")('entity_types.correspondence') }];;
        $scope.search = { entity_type: null };

        $scope.gridOptionsTasksTypes = {
            pdfTitle: $filter('translate')('tasks_types.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,             
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                { name: 'entity_type', displayName: $filter('translate')('tasks_types.entity_type'), cellTemplate: gridService.entityTypeTemplate('entity_type'), enableFiltering: false, enableHiding: false, width: 120 },
                { name: 'color', displayName: $filter('translate')('tasks_types.color'), enableFiltering: false, cellTemplate: gridService.colorTemplate("color"), maxWidth: 30},
                { name: 'name', displayName: $filter('translate')('tasks_types.name'), enableFiltering: true, enableHiding: false },
                {
                    name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('tasks_types.button_edit'), action: 'ui-sref="tasks_types.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit", cssClass: "btn btn-xs btn-default btn-outline btn-custom-laptop" },
                        { title: $filter('translate')('tasks_types.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove", cssClass: "btn btn-xs btn-default btn-outline btn-custom-laptop" }
                    ], { cssClass: "pull-right" })
                },
            ],
            getData: function (options) {             
                options.entity_type = $scope.search.entity_type;

                return Restangular.all('TasksTypes').getList(options);
            }
        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("tasks_types.edit", { id: rowEntity.id });
        }

        $scope.loadData = function () {
            $scope.gridOptionsTasksTypes.loadData(false);
            }

        $scope.deleteDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('tasks_types.button_delete'),
                message: $filter('translate')('tasks_types.delete_message') + " " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('TasksTypes', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('tasks_types.deleted_success'));
                        $scope.gridOptionsTasksTypes.gridApi.core.raise.itemDeleted($scope);
                        
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };
        
    }])

;